import React, { useEffect, useState } from 'react';
import {
  ProductsPage,
  PageHeader,
  PageTitle,
  AddProductButton,
  ProductsStats,
  StatItem,
  StatNumber,
  StatLabel,
} from '../../styles/ProductsStyles';
import { ActionButton, UserActions } from '../../styles/UsersStyles';

import { AddButton, Dropdown, Field, HeadersModal, Input, Item, Label, ListActionButton, ListActions, ListCategory, ListInfo, ListItem, ListItemOne, ListName, ModalContent, ModalOverlay, ProductsList, TabButton, TabHeader, TabsWrapper } from '../../styles/common';
import { useNavigate } from "react-router-dom";
import { CreateCategories, GetCategories, UpdateCategoryStatus } from '../../common/CommonApi';
import Swal from 'sweetalert2';
import styled from 'styled-components';

const Category = () => {
  const [categories, setCategories] = useState([]);
  const [editCat, setEditCat] = useState(false);
  const [editId, setEditId] = useState('');
  const [activeTab, setActiveTab] = useState("tab1");
  useEffect(() => {
    getCategory()
  }, [])
  const getCategory = async () => {
    let data = await GetCategories()
    setCategories(data.data.data)
  }
  const navigate = useNavigate();
  const [addCategory, setAddCategory] = useState(false);
  const [form, setForm] = useState({
    categoryName: '',
    description: '',
    status: false,
    sortOrder: 0,
    showInMenu: false,
    categoryImage: null,
  });

  function SubCategory(id) {
    navigate(`/category/sub-category?id=${id}`);
  }

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    setForm((prevForm) => ({
      ...prevForm,
      [name]:
        type === "checkbox"
          ? checked
          : type === "file"
            ? files[0]   // 👈 will store in form.categoryImage
            : name === "sortOrder"
              ? Number(value)
              : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("categoryName", form.categoryName);
    formData.append("description", form.description);
    formData.append("status", form.status);
    formData.append("sortOrder", form.sortOrder);
    formData.append("showInMenu", form.showInMenu);
    console.log("formData", formData)
    if (form.categoryImage) {
      formData.append("categoryImage", form.categoryImage); // 👈 now works
    }
    try {
      if (editCat) {
        const response = await fetch(`${process.env.REACT_APP_API_URL}categories/${editId}`, {
          method: "PUT",
          body: formData,
        });
        const data = await response.json();
        if (data.message == "SUCCESSFULLY_UPDATED") {
          Swal.fire('Categories Updated.')
          setAddCategory(false)
          getCategory()
        }
        console.log("Success:", data);

      } else {
        const response = await fetch(process.env.REACT_APP_API_URL + "categories", {
          method: "POST",
          body: formData,
        });
        const data = await response.json();
        if (data.message == "SUCCESS_FULLY_CREATED") {
          Swal.fire('Categories Added.')
          setAddCategory(false)
          getCategory()
        }
        console.log("Success:", data);
      }

      // const response = await CreateCategories(formData)


    } catch (err) {
      console.error("Error:", err);
    }
  };

 const handleProductStatusChange = async (e,product) => {
    e.stopPropagation();
    const updatedStatus = !product.status;
    let resp = await UpdateCategoryStatus(product._id,{status:updatedStatus})
    if(resp.data.message === "SUCCESSFULLY_UPDATED"){
      Swal.fire("Status Updated")
      getCategory()
    }
    // console.log("---->>categories",resp)
  }

  const handleEditCatgory = (product) => {
    setAddCategory(true)
    setEditCat(true)
    setEditId(product._id)
    setForm(product);
  }
  return (
    <ProductsPage>
      <PageHeader>
        <PageTitle>Category Management</PageTitle>
        <AddProductButton onClick={() => {
          setAddCategory(true)
          setEditCat(false)
        }}>+ Add New Categories</AddProductButton>
      </PageHeader>
      <ProductsStats style={{ marginBottom: "20px" }}>
        <StatItem>
          <StatNumber>{categories.length}</StatNumber>
          <StatLabel>Total Categories</StatLabel>
        </StatItem>
        <StatItem>
          <StatNumber>{categories.filter(p => p.status === 'Active').length}</StatNumber>
          <StatLabel>Total Sub Categories</StatLabel>
        </StatItem>
        <StatItem>
          <StatNumber>{3}</StatNumber>
          <StatLabel>Active Categories</StatLabel>
        </StatItem>
      </ProductsStats>
      <Wrapper>
        <Table>
          <TabsWrapper style={{ marginTop: "10px" }}>
            {/* Tabs */}
            <TabHeader>
              <TabButton active={activeTab === "tab1"} onClick={() => setActiveTab("tab1")}>
                Active Category
              </TabButton>
              <TabButton active={activeTab === "tab2"} onClick={() => setActiveTab("tab2")}>
                Deactive Category
              </TabButton>
            </TabHeader>
            <Header>
            <div>S No.</div>
            <div>Images</div>
            <div>Category</div>
            <div>Sort Order</div>
            <div>Status</div>
            <div>Actions</div>
          </Header>
            {activeTab === "tab1" &&(
              categories?.filter((item) => item.status).length > 0 ?  categories?.filter((item) => item.status).map((product, id) => (
                <Row key={product._id} onClick={() => SubCategory(product._id)}>
                  <ProductName>{id + 1}</ProductName>
                  <ProductName>
                    <img src={product.categoryImage ? product.categoryImage : '/assets/defaultimage.png'} alt={product.categoryImage} width={50} />
                  </ProductName>
                  <div>
                    <ProductName>{product.categoryName}</ProductName>
                    <ProductDesc>{product.description}</ProductDesc>
                  </div>
                  <div>
                    <ProductName>{product.sortOrder}</ProductName >
                  </div>

                  <Status style={{ cursor: 'pointer' }}
                    onClick={(e) => handleProductStatusChange(e,product)} 
                    value={product.status} verified={product.status}>{product.status ? "Enable" : "Disable"}</Status>
                  <UserActions>
                    <ActionButton className="edit" type="verify"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleEditCatgory(product);
                      }}
                    >✏️</ActionButton>
                  </UserActions>
                </Row>
              )) : <div style={{margin:"100px",display:"flex",justifyContent:"center"}}>No Active Category Found</div>
            )}
            {activeTab === "tab2" && (
               categories?.filter((item) => !item.status).length > 0 ? categories?.filter((item) => !item.status).map((product, id) => (
                <Row key={product._id} onClick={() => SubCategory(product._id)}>
                  <ProductName>{id + 1}</ProductName>
                  <ProductName>
                    <img src={product.categoryImage ? product.categoryImage : '/assets/defaultimage.png'} alt={product.categoryImage} width={50} />
                  </ProductName>
                  <div>
                    <ProductName>{product.categoryName}</ProductName>
                    <ProductDesc>{product.description}</ProductDesc>
                  </div>
                  <div>
                    <ProductName>{product.sortOrder}</ProductName >
                  </div>

                  <Status style={{ cursor: 'pointer' }}
                    onClick={(e) => handleProductStatusChange(e,product)} 
                    value={product.status} verified={product.status}>{product.status ? "Enable" : "Disable"}</Status>
                  <UserActions>
                    <ActionButton className="edit" type="verify"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleEditCatgory(product);
                      }}
                    >✏️</ActionButton>
                  </UserActions>
                </Row>
              )) : <div style={{margin:"100px",display:"flex",justifyContent:"center"}}>No Deactive Category Found</div>
            )}
          </TabsWrapper>
        </Table>
      </Wrapper>
      {
        addCategory &&
        <ModalOverlay>
          <ModalContent>
            <HeadersModal>
              <h2>Add Categories</h2>
              <img onClick={() => setAddCategory(false)} style={{ width: "18px" }} src='https://app.ootfit.com/assets/close.png' />
            </HeadersModal>

            <Field>
              <Label>Category Name</Label>
              <Input name="categoryName"
                value={form.categoryName} onChange={handleChange}
              />
            </Field>
            <Field>
              <Label>Description</Label>
              <Input name="description"
                value={form.description} onChange={handleChange}
              />
            </Field>
            <Field>
              <Label>Status</Label>
              <Dropdown
                value={form.status}
                name="status"
                onChange={handleChange}
              >
                <Item value="yes">Yes</Item>
                <Item value="no">No</Item>
              </Dropdown>
            </Field>
            <Field>
              <Label>Sort Order</Label>
              <Dropdown
                name="sortOrder"
                value={form.sortOrder}
                onChange={handleChange}
              >
                <Item value="1">1</Item>
                <Item value="2">2</Item>
                <Item value="3">3</Item>
                <Item value="4">4</Item>
                <Item value="5">5</Item>
              </Dropdown>
            </Field>
            <Field>
              <Label>Show in Menu</Label>
              <Dropdown
                name="showInMenu"
                value={form.showInMenu}
                onChange={handleChange}
              >
                <Item value="yes">Yes</Item>
                <Item value="no">No</Item>
              </Dropdown>
            </Field>
            <Field>
              <Label>Category Image</Label>
              <Input
                type='file'
                name="categoryImage"
                accept="image/*"
                onChange={handleChange}
              />
            </Field>
            <AddButton onClick={handleSubmit}>{editCat ? 'Edit' : 'Add'}</AddButton>
          </ModalContent>
        </ModalOverlay>
      }
    </ProductsPage>
  );
};

export default Category;



const Wrapper = styled.div`padding: 30px 0px; background: #f7f9fb; min-height: 100vh;`;
const Table = styled.div`width: 100%; border-radius: 12px; background: white; overflow-x: auto; box-shadow: 0 4px 10px rgba(0,0,0,0.05);`;
const Header = styled.div`
  display: grid; grid-template-columns: 120px 1.8fr 1fr 1fr 1fr 0.8fr 1fr; padding: 14px 20px;
  background: #f1f3f6; font-weight: 600; font-size: 14px;
  min-width: 960px;

  @media (max-width: 768px) { display: none; }
`;
const Row = styled.div`
  display: grid; grid-template-columns: 120px 1.8fr 1fr 1fr 1fr 0.8fr 1fr; padding: 14px 20px; align-items: center;
  border-bottom: 1px solid #eee; &:hover { background: #fafafa; }
  cursor:pointer;
  min-width: 960px;

  @media (max-width: 768px) {
    min-width: 0;
    grid-template-columns: 86px 1fr;
    gap: 12px;
    margin: 10px;
    padding: 14px;
    border: 1px solid #e2e8f0;
    border-radius: 10px;

    > :first-child { grid-row: 1 / span 3; }
    > * { min-width: 0; overflow-wrap: anywhere; }
  }

  @media (max-width: 420px) {
    grid-template-columns: 1fr;
    > :first-child { grid-row: auto; }
  }
`;
const ProductName = styled.div`font-weight: 600; font-size: 15px; color: #111; margin-bottom: 3px;`;
const ProductDesc = styled.div`font-size: 13px; color: #555;`;
const Status = styled.div`
  font-size: 13px; font-weight: 500;
  color: ${({ verified }) => (verified ? "#056d3b" : "#a61b1b")};
  background: ${({ verified }) => (verified ? "#d4f5e9" : "#fde4e4")};
  padding: 6px 10px; border-radius: 8px; text-align: center; width: fit-content;
`;
